export default __webpack_public_path__ + "static/medication-29ce0fd41d2eba0bdac7bd8a8cd4a8a6.png";